import get from 'lodash/get';

// eslint-disable-next-line import/prefer-default-export
export const selectPreferences = (state) => get(state, 'preferences', {});
export const selectShowLegacyUI = (state) => get(state, 'preferences.legacyUI', false);
